import { useEffect, useRef } from "react";
import { Card, CardBody, Col } from "reactstrap";
import Sortable from "sortablejs";
import { LI } from "../../../AbstractElements";
import { SimpleLists } from "../../../Constants/Constants";
import { SimpleTreeData } from "../../../Data/BonusUi/Tree";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SimpleSortableList = () => {
  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (listRef.current) {
      Sortable.create(listRef.current, {
        animation: 150,
      });
    }
  }, []);

  return (
    <Col lg="4" sm="6">
      <Card>
        <CommonCardHeader title={SimpleLists} span={SimpleTreeData} />
        <CardBody>
          <ul className="list-group" ref={listRef}>
            <LI>Section 1</LI>
            <LI>Section 2</LI>
            <LI>Section 3</LI>
            <LI>Section 4</LI>
            <LI>Section 5</LI>
          </ul>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SimpleSortableList;
